<script setup lang="ts">
import JournalCardSection from '@/pages/journal/ui/JournalCardSection.vue';

import type { IJournalTopicSection } from '@/entities/journal/model/types';

withDefaults(
  defineProps<{
    sectionsList: IJournalTopicSection[];
    isDetailPage?: boolean;
    isTopics?: boolean;
  }>(),
  {
    isDetailPage: false,
    isTopics: false,
  },
);
</script>

<template>
  <ul class="journal-card-sections">
    <li
      v-for="section in sectionsList"
      :key="section.id"
      class="journal-card-sections__item"
    >
      <JournalCardSection
        :title="section.name"
        :section="section.journals"
        :theme-slug="section.slug"
        :is-detail-page="isDetailPage"
        :is-topics="isTopics"
      />
    </li>
  </ul>
</template>

<style lang="less">
.journal-card-sections {
  .flex-column(@size-x10);

  &__item {
    padding-bottom: @size-x10;

    &:not(:last-child) {
      border-bottom: 1px solid @color-gallery;
    }
  }

  &._detail &__item {
    padding-bottom: 0;
    border-bottom: 0;
  }
}
</style>
